import React from 'react';
import {Header} from '../../g2/header/Header';
import {AsyncSiteHeader} from '../site-header/AsyncSiteHeader';
import {AsyncSiteFooter} from '../site-footer/AsyncSiteFooter';
import {withErrorBoundary} from '../error-boundary/ErrorBoundary';
import MvtTest from '../mvt/MvtTest/MvtTest';
import {TESTS} from '../../../utils/abacus';

export const Layout = ({children, hideHeader}) => (
    <React.Fragment>
        <div className="site-header-root">
            {withErrorBoundary(
                <MvtTest test={TESTS.WHITE_HEADER} report reportOnMount>
                    <AsyncSiteHeader />
                </MvtTest>
            )}
        </div>
        {!hideHeader && <Header />}
        <div className="content-root">
            {children}
        </div>
        <div className="site-footer-root">
            {withErrorBoundary(<AsyncSiteFooter />)}
        </div>
    </React.Fragment>
);
